(function () {

  // ── Gallery Swiper ────────────────────────────────────────────────────────

  function initGallery(section) {
    var swiperEl = section.querySelector('[data-product-swiper]');
    if (!swiperEl) return;

    // Swiper v11 calculates loop clone count from the initial slidesPerView (1.12).
    // On desktop (slidesPerView: 3.5) it needs slides at position ±2 from active,
    // but only 2 clones per side were created. Pad real slides to 9 so Swiper's
    // clone math works at every breakpoint from the start.
    var wrapper = swiperEl.querySelector('.swiper-wrapper');
    var origSlides = Array.from(wrapper.children);
    var imageSlides = origSlides.filter(function(s) { return !s.hasAttribute('data-slide-type'); });
    if (imageSlides.length > 0 && origSlides.length < 9) {
      var cloneIdx = 0;
      while (wrapper.children.length < 9) {
        wrapper.appendChild(imageSlides[cloneIdx % imageSlides.length].cloneNode(true));
        cloneIdx++;
      }
    }

    var sw = new Swiper(swiperEl, {
      // Mobile: 1 full slide + thin edges peeking
      slidesPerView: 1.12,
      centeredSlides: true,
      spaceBetween: 12,
      loop: true,
      watchSlidesProgress: true,

    //   autoplay: {
    //     delay: 5000,
    //     disableOnInteraction: false,
    //     pauseOnMouseEnter: true,
    //   },

      navigation: {
        prevEl: section.querySelector('[data-gallery-prev]'),
        nextEl: section.querySelector('[data-gallery-next]'),
      },

      pagination: {
        el: section.querySelector('.custom-product__pagination'),
        dynamicBullets: true,
        clickable: true,
      },

      breakpoints: {
        // Tablet: 2 full + thin sliver on each side
        750: {
          slidesPerView: 2.3,
          centeredSlides: true,
          spaceBetween: 20,
        },
        // Desktop: 3 full + thin sliver on each side (~7% of width)
        990: {
          slidesPerView: 3.5,
          centeredSlides: true,
          spaceBetween: 24,
        },
      },
    });

    // Swiper v11 loop doesn't always create right-side clones on first render;
    // a deferred update forces it to recalculate and place them correctly.
    requestAnimationFrame(function () {
      sw.update();
    });

    // A gesture starting on the native video control bar (scrubber, play/pause,
    // fullscreen…) must not be hijacked into a slide swipe, but the rest of the
    // video (where users naturally swipe, same as over a photo) should behave
    // exactly like any other slide. Toggle swiper-no-swiping on the video itself,
    // scoped to just that bottom strip, right before Swiper reads it — a
    // capture-phase listener always runs ahead of Swiper's own bubble-phase one.
    var CONTROL_BAR_HEIGHT = 44;
    wrapper.addEventListener('pointerdown', function (e) {
      var video = e.target.closest('.custom-product__slide-video');
      if (!video) return;
      var rect = video.getBoundingClientRect();
      var nearControls = e.clientY > rect.bottom - CONTROL_BAR_HEIGHT;
      video.classList.toggle('swiper-no-swiping', nearControls);
    }, { capture: true, passive: true });

    sw.on('slideChange', function () {
      section.querySelectorAll('.swiper-slide:not(.swiper-slide-active) .custom-product__slide-video').forEach(function (v) {
        v.pause();
      });
      section.querySelectorAll('.swiper-slide:not(.swiper-slide-active) [data-video-host="youtube"] .custom-product__slide-iframe').forEach(function (iframe) {
        iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      });
      section.querySelectorAll('.swiper-slide:not(.swiper-slide-active) [data-video-host="vimeo"] .custom-product__slide-iframe').forEach(function (iframe) {
        iframe.contentWindow.postMessage('{"method":"pause"}', '*');
      });
    });
  }

  // ── Zoom modal (magnifier button on each image slide) ─────────────────────

  function initZoomModal(section) {
    var modal = section.querySelector('[data-zoom-modal]');
    var triggers = section.querySelectorAll('[data-zoom-trigger]');
    if (!modal || !triggers.length) return;

    var swiperEl = modal.querySelector('[data-zoom-swiper]');
    var closeBtn = modal.querySelector('[data-zoom-close]');
    var backdrop = modal.querySelector('[data-zoom-backdrop]');
    var prevBtn  = modal.querySelector('[data-zoom-prev]');
    var nextBtn  = modal.querySelector('[data-zoom-next]');
    if (!swiperEl) return;

    var zoomSwiper = new Swiper(swiperEl, {
      zoom: {
        maxRatio: 3,
        minRatio: 1,
      },
      loop: false,
      keyboard: {
        enabled: true,
      },
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
      },
    });

    function openModal(index) {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      zoomSwiper.update();
      zoomSwiper.slideTo(index, 0);
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      if (zoomSwiper.zoom) zoomSwiper.zoom.out();
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(parseInt(btn.dataset.zoomIndex, 10) || 0);
      });
    });

    // Clicking the image itself (not just the magnifier button) also opens the zoom modal.
    section.querySelectorAll('.custom-product__slide-img').forEach(function (img) {
      var wrapper = img.closest('.custom-product__slide-inner');
      var btn = wrapper && wrapper.querySelector('[data-zoom-trigger]');
      if (!btn) return;
      img.addEventListener('click', function () {
        openModal(parseInt(btn.dataset.zoomIndex, 10) || 0);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  // ── Variant selection + price update ─────────────────────────────────────

  function initAside(section) {
    var priceEl        = section.querySelector('[data-product-price]');
    var comparePriceEl = section.querySelector('[data-product-compare-price]');
    var radios         = section.querySelectorAll('[data-variant-radio]');
    var reserveBtn     = section.querySelector('[data-reserve-btn]');
    var mobAtcBtn      = section.querySelector('[data-mob-atc-btn]');

    if (!radios.length) return;

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (priceEl) {
          priceEl.textContent = this.dataset.formattedPrice;
        }
        if (comparePriceEl) {
          var hasCompare = this.dataset.hasComparePrice === 'true';
          comparePriceEl.textContent = this.dataset.formattedComparePrice;
          comparePriceEl.hidden = !hasCompare;
        }
        if (reserveBtn) {
          reserveBtn.dataset.variantId = this.value;
          var available = this.dataset.available === 'true';
          reserveBtn.textContent = available
            ? reserveBtn.dataset.labelAvailable
            : reserveBtn.dataset.labelUnavailable;
          reserveBtn.disabled = !available;
          reserveBtn.classList.toggle('custom-product__reserve-btn--unavailable', !available);
        }
        if (mobAtcBtn) {
          mobAtcBtn.dataset.variantId = this.value;
          var avail = this.dataset.available === 'true';
          mobAtcBtn.textContent = avail
            ? mobAtcBtn.dataset.labelAvailable
            : mobAtcBtn.dataset.labelUnavailable;
          mobAtcBtn.disabled = !avail;
          mobAtcBtn.classList.toggle('custom-product__mob-btn--unavailable', !avail);
        }
      });
    });

    if (reserveBtn) {
      reserveBtn.addEventListener('click', function () {
        addToCart(this.dataset.variantId, this, this.dataset.productId);
      });
    }

    if (mobAtcBtn) {
      mobAtcBtn.addEventListener('click', function () {
        addToCart(this.dataset.variantId, this, this.dataset.productId);
      });
    }
  }

  // ── Cart icon bubble update ───────────────────────────────────────────────

  function updateCartIconBubble(response) {
    if (!response.sections || !response.sections['cart-icon-bubble']) return;
    var bubbleEl = document.getElementById('cart-icon-bubble');
    if (!bubbleEl) return;
    var parser = new DOMParser();
    var doc = parser.parseFromString(response.sections['cart-icon-bubble'], 'text/html');
    bubbleEl.innerHTML = doc.body.innerHTML;
  }

  // ── Cart exclusivity: max 1 qty, one variant per product ─────────────────

  function enforceExclusiveCart(productId, newVariantId) {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        var alreadyAtOne = false;

        cart.items.forEach(function (item) {
          var sameProduct = String(item.product_id) === String(productId);
          var sameVariant = String(item.variant_id) === String(newVariantId);

          if (sameVariant && item.quantity === 1) {
            alreadyAtOne = true;
          } else if (sameVariant && item.quantity !== 1) {
            // Wrong quantity for the same variant — correct it
            updates[item.key] = 1;
          } else if (sameProduct && !sameVariant) {
            // Different variant of same product — remove it
            updates[item.key] = 0;
          }
        });

        if (alreadyAtOne && Object.keys(updates).length === 0) {
          return { skip: true };
        }

        if (Object.keys(updates).length === 0) {
          return null;
        }

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates }),
        })
          .then(function (r) { return r.json(); })
          .then(function () { return alreadyAtOne ? { skip: true } : null; });
      });
  }

  // ── Add to cart ───────────────────────────────────────────────────────────

  function addToCart(variantId, btn, productId) {
    if (!variantId) return;

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    var doAdd = productId
      ? enforceExclusiveCart(productId, variantId)
      : Promise.resolve(null);

    doAdd
      .then(function (result) {
        if (result && result.skip) {
          // Variant already in cart at qty=1 — just open the cart
          if (cart && cart.open) {
            cart.open();
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          btn.textContent = 'Added!';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
          return;
        }

        var formData = new FormData();
        formData.append('id', parseInt(variantId, 10));
        formData.append('quantity', 1);
        formData.append('sections_url', window.location.pathname);

        var sectionIds = (cart && cart.getSectionsToRender)
          ? cart.getSectionsToRender().map(function (s) { return s.id; })
          : [];
        if (sectionIds.indexOf('cart-icon-bubble') === -1) {
          sectionIds.push('cart-icon-bubble');
        }
        formData.append('sections', sectionIds);

        var url = (window.routes && window.routes.cart_add_url) || '/cart/add';

        return fetch(url, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript',
          },
          body: formData,
        })
          .then(function (r) { return r.json(); })
          .then(function (response) {
            if (response.status) {
              console.error('Cart add error:', response.description);
              btn.textContent = originalText;
              btn.disabled = false;
              return;
            }

            btn.textContent = 'Added!';

            if (cart && cart.renderContents) {
              cart.renderContents(response);
            }

            updateCartIconBubble(response);

            // Elitweb 26.10.2026: no cart popup/drawer on this theme -> open the cart page as the confirmation
            if (!cart) {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
              return;
            }

            if (typeof publish !== 'undefined' && window.PUB_SUB_EVENTS) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              });
            }

            setTimeout(function () {
              btn.textContent = originalText;
              btn.disabled = false;
            }, 2000);
          });
      })
      .catch(function (err) {
        console.error('Cart add error:', err);
        btn.textContent = originalText;
        btn.disabled = false;
      });
  }

  // ── Mobile CTA visibility (show after gallery scrolls out of view) ────────

  function initMobCta(section) {
    var ctaBar = section.querySelector('[data-mob-cta]');
    var gallery = section.querySelector('[data-product-gallery]');
    if (!ctaBar || !gallery) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          ctaBar.classList.remove('is-visible');
        } else if (entry.boundingClientRect.bottom < 0) {
          // Gallery is above viewport — user scrolled past images
          ctaBar.classList.add('is-visible');
        } else {
          // Gallery is below viewport — page just loaded, not yet reached
          ctaBar.classList.remove('is-visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(gallery);
  }

  // ── Init ──────────────────────────────────────────────────────────────────

  function init() {
    document.querySelectorAll('[data-section-custom-product]').forEach(function (section) {
      initGallery(section);
      initZoomModal(section);
      initAside(section);
      initMobCta(section);
      // Reveal after all JS has initialized to avoid flash of unstyled Swiper
      requestAnimationFrame(function () {
        section.closest('.section-custom-product').classList.add('is-ready');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
